import { EntityAttendance } from "../entity/EntityAttendance";
import { DtoAttendancesPutRes } from "./abst/DtoAttendancesPutRes";

export class DtoAttendancesPutResImple extends DtoAttendancesPutRes {
  public message: string | null = null;
}
